import { Link, useNavigate } from 'react-router-dom'
import { useZocksQuota } from '../ScopedBlock/hooks'
import { Col, Container, Row } from 'react-bootstrap'
import { ScopedBlock } from '../ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../ScopedBlock/models'
import PrizeBadge from '../ScopedBlock/PrizeBadge.svg?url'
import { Button } from '../Button/Button'
import React from 'react'

export const DedicatedPhoneIntegrationTool = () => {
  const navigate = useNavigate()
  const { hasQuota } = useZocksQuota()
  const sharedPhoneLineAvailable = hasQuota('integration.sharedPhoneLine.value')
  return (
    <Container className='d-flex flex-column gap-4 justify-content-between h-100 p-0'>
      <Row>
        <Col xs='auto' className='gx-3'>
          <div className='flex rounded integration-icon-wrapper'>
            <i className='bi bi-telephone '></i>
          </div>
        </Col>
        <Col>
          <h5>Invite Zocks to your Phone Calls</h5>
          <div className='paragraph-medium zocks-text-gray-600'>Analyze and summarize conversations from mobile and landline phone calls.</div>
          <div className='paragraph-medium zocks-text-gray-600'>
            For the AI Assistant for shared lines and call solutions{' '}
            {sharedPhoneLineAvailable ? (
              <ScopedBlock
                scope={{
                  scope: 'account:update',
                  superScope: ['account:admin'],
                }}
                missingScopeAction={MissingScopeAction.DISABLE}
              >
                <Link className='button-link-medium zocks-text-primary' to={`/workspace/setup/settings`}>
                  configure your settings
                </Link>
              </ScopedBlock>
            ) : (
              <ScopedBlock
                scope={{
                  scope: 'account:update',
                  superScope: ['account:admin'],
                }}
                missingScopeAction={MissingScopeAction.DISABLE}
              >
                <Link className='button-link-medium zocks-text-primary' to='/account/plan'>
                  upgrade call support
                  <img alt='Upgrade' src={PrizeBadge} />
                </Link>
              </ScopedBlock>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Container className='upcoming-integration-bottom-box'>
          <Row className='align-items-center'>
            <Col>
              <div className='paragraph-small zocks-text-gray-600 align-content-center label-container'>Supports mobile and landline phones.</div>
            </Col>
          </Row>
          <Row className='d-flex align-items-center m-0'>
            <Col className='d-flex justify-content-end p-0'>
              <ScopedBlock
                scope={{
                  scope: 'room_session:start',
                  superScope: ['room_session:admin', 'room:admin'],
                }}
                missingScopeAction={MissingScopeAction.DISABLE}
              >
                <Button variant='primary' className='w-100 px-0' onClick={() => navigate('/account/profile-settings/integrations')}>
                  Link your phone number
                </Button>
              </ScopedBlock>
            </Col>
          </Row>
        </Container>
      </Row>
    </Container>
  )
}
